import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const LogicalIfThen = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter vidSrc={1194426058} />
    </div>
  );
};

export default LogicalIfThen;
